import {
  getRelativeFontSize,
  regularFont,
  theme,
} from "../../../../utils/styles";

const rahuTransitDialogStyles = {
  modalHeader: {
    ...regularFont,
    fontSize: getRelativeFontSize(10),
    color: "#222222",
    textAlign: "center",
  },
  dialogContent: {
    margin: "0 5%",
    [theme.breakpoints.down("sm")]: {
      margin: "0 0%",
    },
  },
  transitBox: {
    width: "100%",
    justifyContent: "center",
    backdropFilter: "blur(5.5px)",
    background: "transparent",
    borderRadius: "10px",
    backgroundClip: "content-box,border-box",
    backgroundImage:
      "linear-gradient(#fff,#fff),linear-gradient(90deg,#DF66E3 -0.11%,#5E75FF 55.68%, #2CF1DF 100.01%)",
    backgroundOrigin: "border-box",
    border: "double 2px transparent",
    textAlign: "center",
  },
  subHeaderText: {
    ...regularFont,
    fontSize: getRelativeFontSize(7),
    color: "#222222",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(4),
    },
  },
  contentText: {
    ...regularFont,
    fontSize: getRelativeFontSize(3),
    color: "#222222",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
  noteText: {
    ...regularFont,
    fontSize: getRelativeFontSize(3),
    color: "#222222",
    textAlign: "start",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
  transitHeader: {
    ...regularFont,
    fontSize: getRelativeFontSize(5),
    color: "#222222",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  legendDescText: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#222222",
    display: "list-item",
    listStyle: "square",
    ml: "30px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
} as const;

export default rahuTransitDialogStyles;
